<template>
  <div class="footer"
    style="margin-top: 46px; width: 100%; font-size: 12px;    color: #7d90b2;text-align: center;display: flex;align-items: center;justify-content: center;">
    <span style="margin-right: 8px;">{{ $t("login.copyright") }}</span>
    <a href="http://beian.miit.gov.cn/" style="text-decoration: none; color: #7d90b2;" target="_blank">闽ICP备05020903号-4</a>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  computed: {},
};
</script>
